import { render, staticRenderFns } from "./tnbLogin.vue?vue&type=template&id=1256e5b9&"
import script from "./tnbLogin.vue?vue&type=script&lang=js&"
export * from "./tnbLogin.vue?vue&type=script&lang=js&"
import style0 from "./tnbLogin.vue?vue&type=style&index=0&id=1256e5b9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports